import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import pickBy from 'lodash/pickBy';
import { pending } from 'redux-saga-thunk';
import identity from 'lodash/identity';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { change, reduxForm } from 'redux-form';
import { notification } from 'antd';
import { fromEntities } from '../store/selectors';
import InStoreTab from '../components/organisms/InStoreTab';
import { createValidator, float, integer, minSize, required, url } from '../services/validation';
import { resourceDetailReadRequest, resourceUpdateRequest } from '../store/resource/actions';

class InStoreTabContainer extends Component {
  static propTypes = {
    getInStore: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showDeviceCaps: false,
      showCreateInStoreMoment: false,
    };
  }

  componentDidMount() {
    this.props.getInStore().catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not retrieve inStore data.',
        duration: 0,
      })
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading) {
      // Show device caps if the line item has it
      if (this.props.initialValues.impression_interval) {
        this.toggleDeviceCaps();
      }
    }
  }

  toggleDeviceCaps = () => {
    this.setState({ showDeviceCaps: !this.state.showDeviceCaps }, () => {
      // Remove if device caps are not shown
      if (!this.state.showDeviceCaps) {
        // IM-2167
        this.props.change('impression_limit', null);
        this.props.change('impression_interval', null);
      }
    });
  };

  toggleInStoreMoment = () => {
    this.setState({
      showCreateInStoreMoment: !this.state.showCreateInStoreMoment,
    });
  };

  render() {
    const { showCreateInStoreMoment, showDeviceCaps } = this.state;
    return (
      <InStoreTab
        key={2}
        toggleDeviceCaps={this.toggleDeviceCaps}
        toggleInStoreMoment={this.toggleInStoreMoment}
        showCreateInStoreMoment={showCreateInStoreMoment || this.props.hasInstore}
        showDeviceCaps={showDeviceCaps}
        {...this.props}
      />
    );
  }
}

const onSubmit = (values, dispatch, props) => {
  const submission = pickBy(values, identity);
  submission.cpe = parseFloat(submission.cpe);
  submission.creative_service_id = parseInt(submission.creative_service_id, 10);
  submission.pacing_type = 'guaranteed_impressions';
  submission.budget = parseInt(values.budget, 10);

  return props
    .updateInStore(submission)
    .then(() =>
      notification.success({
        message: 'Success',
        description: 'inStore settings saved',
        duration: 4,
      })
    )
    .catch(e =>
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not save inStore settings.',
        duration: 0,
      })
    );
};

const validate = createValidator({
  budget: [integer, required, minSize(0)],
  width: [integer, required, minSize(0)],
  height: [integer, required, minSize(0)],
  cpe: [float],
  impression_limit: [integer, minSize(0)],
  impression_interval: [integer, minSize(0)],
  creative_url: [required, url],
  creative_image: [required],
  creative_html: [required],
  click_through_url: [url],
});

const mapStateToProps = (
  { modal, ...state },
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  loading: pending(state, 'advertiserAdInstoreDetailRead'),
  hasInstore: !!get(
    fromEntities.getDetail(state, 'advertiserAdInstore', lineItemId),
    'creative_service_id',
    false
  ),
  initialValues: {
    cpe: 0.65,
    priority: 5,
    budget_type: 'day',
    budget: 1000,
    ...fromEntities.getDetail(state, 'advertiserAdInstore', lineItemId),
  },
});

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  change: (field, value) => dispatch(change('JobsForm', field, value)),
  getInStore: () =>
    dispatch(resourceDetailReadRequest('advertiser-ad/:id/instore', { id: lineItemId })),
  updateInStore: data =>
    dispatch(resourceUpdateRequest('advertiser-ad/:id/instore', { id: lineItemId }, data)),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'InStoreTab',
    onSubmit,
    validate,
    enableReinitialize: true,
  })
)(InStoreTabContainer);
